import { render, staticRenderFns } from "./AR-ArchivesFuzzySearch.vue?vue&type=template&id=b0f2e636&"
import script from "./AR-ArchivesFuzzySearch.vue?vue&type=script&lang=js&"
export * from "./AR-ArchivesFuzzySearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports